module.exports = __webpack_public_path__ + "static/media/ivo-nft-big.d105a5dc.png";